import React from 'react';
import styles from './CrmConnect.module.scss';
import { Flex } from 'antd';
import {ReactComponent as CheckBoxIcon} from "../../../assets/images/global-icons/Checkbox.svg"
interface CrmOptionProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const CrmOption: React.FC<CrmOptionProps> = ({ label, isActive, onClick }) => {
  return (
    <Flex className={`${styles.item} ${isActive ? styles.active : ''}`} onClick={onClick}>
      <span>{label}</span>
      <div className={styles.checkbox}>{isActive && <CheckBoxIcon/>}</div>
    </Flex>
  );
};
